<template>
  <select
    :value="selectedEgId"
    :disabled="events.length <= 1"
    class="e4s-input-field e4s-input-field--primary e4s-event-jump-select"
    @change="onChanged"
  >
    <option value="" disabled>Please select...</option>
    <option
      v-for="event in events"
      :key="event.egId"
      :value="event.egId"
    >
      {{ event.typeNo }}: {{ event.name }}
    </option>
  </select>
</template>

<script setup lang="ts">
import { type PropType } from 'vue'
import type { CompEvent } from '@/components/results/store-comp-results'

defineProps({
  events: {
    type: Array as PropType<CompEvent[]>,
    required: true
  },
  selectedEgId: {
    type: Number,
    required: true
  }
})

const emit = defineEmits<{
  (e: 'onEventJump', egId: number): void
}>()

function onChanged(event: Event) {
  const target = event.target as HTMLSelectElement
  emit('onEventJump', Number(target.value))
}
</script>

<style>
.e4s-event-jump-select {
  font-size: small;
  max-width: 250px;
  padding: 2px 4px;
}
</style>
